import { Component } from 'react';
import { connect } from "react-redux";
import { Card, Table, Button, Row, Col, Container } from 'react-bootstrap'
import { bellIconHollow, expandIcon } from '../../img/font_awesome/font_awesome';
import UserView from '../userView/UserView'
import UserViewEntry from '../userView/UserViewEntry'
import translations from "../../config/translation/home_translations.json"
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../constants/constants";

const VISIBLE_ROWS = 10; 

const mapStateToProps = (state) => {
    return {
        language: state.languageReducer ? state.languageReducer : 'ENGLISH',
        selectedAlert: state.userViewSelectedAlertReducer
    };
}

const matchDispatchToProps = (dispatch) => {
    return {
        resetSelectedAlert: () => dispatch({ type: 'RESET_SELECTED_ALERT' })
    }
}

class AlertList extends Component {
    state = {
        showUserViewModal: false,
        showEntryModal: false,
        myAlerts: [],
        loadingStatus: ""
    }

    handleKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            this.setState({
                 showUserViewModal: true
            })
        }
    }

    handleClick = () => {
        this.setState({
            showUserViewModal: true
        })
    }

    handleOpenAlertEntry = (event) => {
        if (event) {
            event.preventDefault();
        }

        this.setState({
            showUserViewModal: false,
            showEntryModal: true
        })
    }

    handleNewAlertEntry = (event) => {
        if (event) {
            event.preventDefault();
        }

        this.props.resetSelectedAlert();

        this.setState({
            showUserViewModal: false,
            showEntryModal: true
        })
    }


    handleClose = () => {
        this.props.resetSelectedAlert();
        this.setState({
            showUserViewModal: false,
            showEntryModal: false
        })
    }

    showLoading = () => {
        if (this.state.loadingStatus === "") {
            this.setState({
                loadingStatus: LOADING_STATUES.LOADING
            })
            return true;
        }
        return false;
    }

    hideLoading = () => {
        this.setState({
            loadingStatus: ""
        })
    }

    componentDidMount() {
        this.showLoading();
        axios.get(configData.LANDNOTIFICATION_SERVER_URL + "home/myAlerts?language=" + this.props.language, { withCredentials: true })
            .then(
                (response) => {
                    const content = response.data.content;
                    let myAlerts = content.alerts;
                    if (!myAlerts || myAlerts.length === 0) {
                        myAlerts = []
                    }

                    this.setState({
                        myAlerts
                    }, function () {   // callback function after the state is set
                        this.hideLoading();
                    });
                },
                (error) => {
                    handleError(error, this.props.history);
                }
            );
    }

    render() {

        let alertRows = <div style={{ fontWeight: 'bold' }}>Click on the above "Add New Alert" button to create your very first alert.</div>
        let expandButton = <></>
        let detailsButton = <></>
        if (this.state.myAlerts && this.state.myAlerts.length > 0) {
            alertRows = <Table size='sm'>
                <tbody>
                    <tr>
                        <th className="table-td-xs">{translations[this.props.language].alert}</th>
                        <th className="table-td-xs">{translations[this.props.language].criteria}</th>
                        <th className="table-td-xs">{translations[this.props.language].status}</th>
                    </tr>
                    {   
                        this.state.myAlerts &&
                        this.state.myAlerts.map((myAlert, index) => {
                            if (index < VISIBLE_ROWS) {
                                return <tr key={index}>
                                    <td className="table-td-xs">{myAlert.name}</td>
                                    <td className="table-td-xs">{myAlert.criteria}</td>
                                    <td className="table-td-xs">{myAlert.deliveryMethodStatus}</td>
                                </tr>
                            }
                        })
                    }

                    { 
                        this.state.myAlerts && 
                       this.state.myAlerts.length > VISIBLE_ROWS &&
                        <tr key={"1" + VISIBLE_ROWS}>
                            <td className="table-td-xs"></td>
                            <td className="table-td-xs"></td>
                            <td className="table-td-xs"><span className='badge badge-light'>{translations[this.props.language].more}</span></td>
                        </tr>
                    }
                </tbody>
            </Table>
            expandButton = <span onClick={this.handleClick} id='expandAlertList' onKeyDown={this.handleKeyDown} tabIndex={0} style={{ cursor: "pointer", float: 'right' }}>{expandIcon} <span className="sr-only">Expand My Alerts Window</span></span>
            detailsButton = <Button variant="primary" className='btn-sm' onClick={this.handleClick}>{translations[this.props.language].details}</Button>
        }

        return (
            <>
                <Card>
                    <Card.Header style={{ backgroundColor: '' }}>
                        {bellIconHollow}&nbsp;&nbsp;{translations[this.props.language].my_alerts} {expandButton}
                    </Card.Header>
                    <Card.Body>
                        <Container>
                            <Row>
                                <Col style={{ textAlign: 'right' }}><Button onClick={this.handleNewAlertEntry} ref={this.props.skipRef} className="focus-ring shadow-boxed-button" style={{ fontWeight: 'bold', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.39)" }}>{translations[this.props.language].add_new_alert}</Button></Col>
                            </Row>
                            <Row>
                                &nbsp;
                            </Row>
                            <Row>
                                <Col>
                                    {alertRows}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                {detailsButton}
                                </Col>
                            </Row>
                        </Container>
                       
                    </Card.Body>
                </Card>
                {   
                    this.state.myAlerts &&
                    <UserView  show={this.state.showUserViewModal} handleClose={this.handleClose} handleNewAlertEntry={this.handleNewAlertEntry} handleOpenAlertEntry={this.handleOpenAlertEntry} />
                }
                <UserViewEntry key={this.props.selectedAlert.id} show={this.state.showEntryModal} handleClose={this.handleClose} alertId={0} />
            </>
        )
    }
}

export default connect(mapStateToProps, matchDispatchToProps)(AlertList);
